import { CarrierTypesService, EnumDto } from '@/api';

export default {
  getCarrierTypes: async (): Promise<EnumDto[]> => {
    const response = await CarrierTypesService.carrierTypesControllerGetAll();
    return response.data;
  },
};
